var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-8 bg-neutral-300"},[_c('Lynx-Title',{attrs:{"text":"Acessos do cliente"}}),_c('div',{staticClass:"grid grid-cols-3 gap-8"},_vm._l((_vm.acessoItems),function(item){return _c('AcessoItem',{key:item.id,attrs:{"acesso-item":item},on:{"update-acesso":_vm.onUpdateAcesso}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }